import { makeStyles, createStyles } from '@material-ui/core/styles';

const editPhysician = makeStyles((theme) =>
  createStyles({
    paper: {
      marginTop: theme.spacing(8),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }
  })
);

export default editPhysician;
